import React from 'react';
import withModal, { WithModalProps } from 'hoc/with-modal';
import { useTranslation } from 'i18n';
import Button from 'components/button';
import If from 'components/if-statement';
import BarsLoader from 'components/bars-loader';
import { H2 } from 'components/typography';
import { CloseModalIcon } from 'components/icons/style';
import { Row, WithMargin } from 'components/layout';
import { renderChildren } from 'utils/react';
import { typography } from 'styles/settings';
import { Children } from 'utils/types/react';

export interface DialogConfirmProps extends WithModalProps {
  children: Children;
  title: string;
  onCancel: Function;
  onConfirm: Function;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
}

function DialogConfirm({ modal, children, ...props }: DialogConfirmProps) {
  const { t } = useTranslation();

  const { confirmLabel = t('Confirm'), cancelLabel = t('Cancel') } = props;

  function onCancel() {
    if (props.onCancel) {
      props.onCancel();
    }

    modal.hide();
  }

  function onConfirm(event) {
    modal.hide();
    props.onConfirm(event);
  }

  return (
    <>
      <H2>{props.title}</H2>
      <CloseModalIcon onClick={modal.hide} />
      <If condition={props.isLoading}>
        <If.Then>
          <BarsLoader />
        </If.Then>
        <If.Else>
          {renderChildren(children, { modal, ...props })}
          <Row>
            <WithMargin right={typography.size.md}>
              <Button label={confirmLabel} onClick={onConfirm} />
            </WithMargin>
            <Button label={cancelLabel} onClick={onCancel} secondary />
          </Row>
        </If.Else>
      </If>
    </>
  );
}

export default withModal(DialogConfirm);
